var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfileInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9494 0H0V79.6936H75.9494V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9747 48.2928C51.3756 48.2928 62.2393 37.482 62.2393 24.1464C62.2393 10.8107 51.3756 0 37.9747 0C24.5737 0 13.7101 10.8107 13.7101 24.1464C13.7101 37.482 24.5737 48.2928 37.9747 48.2928Z",
    fill: "#728EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 65.8462C0 56.1905 9.68035 49.499 18.773 52.8694L30.1687 57.0935C35.2037 58.9599 40.7456 58.9599 45.7807 57.0935L57.1764 52.8694C66.2689 49.499 75.9494 56.1905 75.9494 65.846C75.9494 73.4941 69.7191 79.6936 62.0336 79.6936H13.9156C6.23022 79.6936 0 73.4941 0 65.8462Z",
    fill: "#728EBC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.9494,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileInactive);
export default __webpack_public_path__ + "static/media/edit-profile-inactive.12af1b1a2956c5808724d01f57e23a3a.svg";
export { ForwardRef as ReactComponent };